import { ReduxStateActivity } from "../types/redux/reduxStateActivity";
import { ReduxStateAuth } from "../types/redux/reduxStateAuth";
import moment from "moment";
import { ReduxStateConsumptionDetails } from "../types/redux/reduxStateConsumptionDetails";
import { ReduxStateLabelling } from "../types/redux/reduxStateLabelling";
import { ModalType } from "../components/common/Modals/types/modalType";
import { ReduxStatePalletCache } from "../types/redux/reduxStatePalletCache";
import { ReduxStatePalletEdit } from "../types/redux/reduxStatePalletEdit";
import { getNextSixAm, getSixAmDaysBack } from "../aplUtils/dateHelper";
import { ReduxStatePalletSearch } from "../types/redux/reduxStatePalletSearch";
import { ReduxStateWorkorderitems } from "../types/redux/reduxStateWorkorderItems";
import { ReduxStateWorkorderManagement } from "../types/redux/reduxStateWorkorderManagement";
import { ReduxStatePrintHistoryFooters } from "../types/redux/reduxStatePrintHistoryFooters";
import { ReduxStateAdmin } from "../types/redux/reduxStateAdmin";
import { ReduxStateSchedules } from "../types/redux/reduxStateSchedules";
import { ReduxStateModalPallets2 } from "../types/redux/reduxStateModalPallets2";
import { ReduxStateReprint } from "../types/redux/reduxStateReprint";
import { PalletStatus } from "../types/palletStatus";
import { PalletCondition } from "../types/palletCondition";

const initialStateActivitiy: ReduxStateActivity = {
    actConsLoading: false,
    actCons: [],
    actConsError: null,
    actConsFirstLoaded: false,
    actConsClosedLineId: null,

    actLablLoading: false,
    actLabl: [],
    actLablError: null,
    actLablFirstLoaded: false,
    actLablClosedLineId: null
};

const initialStateAuth: ReduxStateAuth = {
    loading: false,
    sites: [],
    lines: [],
    departments: [],
    refreshing: false,
    defectTypes: [],
    token: "",
    refreshToken: "",
    sessionId: "",
    error: null,
    userName: "",
    userId: "",
    userLinePermissions: [],
    userLinePermissionsSet: [],
    aplParameters: [],
    culture: "en-GB",
    passwordValidUntil: new Date(),
    passwordWarnDays: 0,
    userSessions: [],
    theme: {
        consumptionColour: "",
        labellingColour: ""
    },
    version: "",
    messageBanner: ""
};

const initialStateConsumptionDetails: ReduxStateConsumptionDetails = {
    consumptionDetails: [],
    offline: false,
    consumptionDetailsLoading: true,
    consumptionDetailsFirstLoaded: false,
    consumptionDetailsError: null,
    selectedConsumptionDetails: [],
    dateStartSelectorDate: moment().toObject(),
    dateEndSelectorDate: moment().toObject(),
    currentActivity: [],
    currentActivityError: null,
    currentActivityLoading: false,
    consumedPallet: [],
    manualBarcodeInput: false,
    consumptionOperationError: null
};

const initialStateLabelling: ReduxStateLabelling = {
    activities: [],
    activitiesLoading: false,
    activitiesErrorMessage: "",
    offline: false,
    offlineTimeStamp: moment().toObject(),
    selectedQtyCount: 0,
    selectedCopiesCount: 0,
    selectedPalletCount: 0,
    selectedPrinterId: 0,
    selectedLabelId: 0,
    printingProgress: 0,
    offlinePrinters: [],
    offlinePrintersLoading: false,
    offlinePrintersErrorMessage: "",
    printed: [],
    combinedPdf: "",
    labels: [],
    labelsLoading: false,
    labelsErrorMessage: "",
    userNumberOfCopiesPerPalletChanged: false,
    lastUpdated: new Date('2000-01-01')
};

const initialStateModalPallets2: ReduxStateModalPallets2 = {
    pallets: [],
    modified: false,
    originalStatus: -1,
    error: null,
    loading: false,
    modalShown: ModalType.None,
    caller: ModalType.None,
    consumptionState: null,
    message: ""
};

const initialStatePalletEdit: ReduxStatePalletEdit = {
    palletDetails: [],
    palletDetailsLoding: false,
    palletDetailsFirstLoaded: false,
    palletDetailsError: null
};

const initialStatePalletSearch: ReduxStatePalletSearch = {
    filters: {},
    sort: {
        field: [],
        direction: []
    },
    page: 1,
    dateStartSelectorDate: getSixAmDaysBack(3).toObject(),
    dateEndSelectorDate: getNextSixAm().toObject(),
    bulk: false,
    palletsLoading: false,
    dateSelectionChanged: true,
    bulkLine: "",
    bulkWorkorder: "",
    bulkBatch: "",
    bulkLot: "",
    bulkMaterial: "",
    bulkStartRank: null,
    bulkEndRank: null,
    bulkStatus: PalletStatus.Undetermined,
    bulkCondition: PalletCondition.Undetermined,
    qualitySwitch: false,
    showAllPallets: false,
    ssccSearch: ""
};

const initialStatePalletCache: ReduxStatePalletCache = {
    palletsBaseData: [],
    palletsLoadErrorMessage: null,
    palletsUpdateErrorMessage: null,
    palletsFirstLoaded: false,
    palletsLoading: false,
    selectedPallets: [],
    modalShown: ModalType.None,
    currentGridPage: 0,
    lastUpdateOrSelect: new Date(),
    palletSearch: initialStatePalletSearch
};

const initialStateWorkorderitems: ReduxStateWorkorderitems = {
    workorderItems: [],
    dateStartSelectorDate: getSixAmDaysBack(90).toObject(),
    dateEndSelectorDate: getSixAmDaysBack(-30).toObject(),
    workorderItemsFirstLoaded: false,
    workorderItemsLoading: false,
    workorderItemsError: null,
    selectedWorkorders: [],
    sort: { field: [], direction: [] },
    filters: {},
    page: 1,
    showClosed: false,
    workorderSearch: "",
    assignedCons: null,
    assignedLabl: null
};

const initialStateWorkorderManagement: ReduxStateWorkorderManagement = {
    orderData: null,
    orderDataLoading: false,
    orderDataError: null,
    orderDataDirty: false,

    orderMaterialData: null,
    ordermaterialDataLoading: false,
    orderMaterialDataError: null,
    orderMaterialDataDirty: false,

    orderOperationsData: [],
    orderOperationsSelected: [],
    orderOperationsDataLoading: false,
    orderOperationsDataError: null,

    orderBomsData: [],
    orderBomsSelected: [],
    orderBomsDataLoading: false,
    orderBomsDataError: null,
    orderBomsAdding: [],

    orderBatchesData: [],
    orderBatchesSelected: [],
    orderBatchesDataLoading: false,
    orderBatchesDataError: null,
    orderBatchesAdding: [],
    orderBatchesAddingMultiple: false,
    orderBatchesAddingMultipleDays: 0,

    orderBobsData: [],
    orderBobsSelected: [],
    orderBobsDataLoading: false,
    orderBobsDataError: null,
    orderBobAdding: null,

    alternatingWokrordersData: [],
    alternatingWokrordersDataLoading: false,
    alternatingWokrordersDataError: null,

    testPrintSelectedLabelId: 0,
    testPrintSelectedPrinterId: 0,
    testPrintPrinters: [],

    labelsData: null,
    labelsDataLoading: false,
    labelsDirty: false
};

const initialStatePrintHistoryFooters: ReduxStatePrintHistoryFooters = {
    printHistoryFooters: [],
    printHistoryFootersLoading: false,
    printHistoryFootersErrorMessage: ""
};

const initialStateAdmin: ReduxStateAdmin = {
    departments: [],
    departmentsDirty: false,
    printerLineSelection: [],
    printerLineSelectionDirty: false,
    aplUsers: [],
    selectedAplUser: [],
    aplRoles: [],
    selectedAplRole: [],
    aplFeatures: [],
    selectedAplFeature: [],
    aplRoleFeatures: [],
    selectedAplRoleFeature: [],
    userWorkcentreRoles: [],
    sites: [],
    lines: [],
    selectedLines: [],
    addUserUsername: "",
    addUserPassword: "",
    addUserSiteId: 0,
    userPasswordReset: "",
    printers: [],
    loading: false,
    error: null,
    selectedAplFeatureDirty: false
};

const initialStateSchedules: ReduxStateSchedules = {
    schedules: [],
    selectedSchedule: [],
    schedulesLoading: false,
    schedulesErrorMessage: "",

    workorders: [],
    selectedWorkorder: [],
    workordersLoading: false,
    workordersErrorMessage: ""
};

const initialStateReprint: ReduxStateReprint = {
    reprintLabels: [],
    reprintLabelsLoading: false,
    reprintLabelsErrorMessage: "",
    reprintPrinters: [],
    reprintPrintersLoading: false,
    reprintPrintersErrorMessage: "",
    selectedReprintLabelId: 0,
    selectedReprintPrinterId: 0,
    reprintCopies: 0,
    reprinted: [],
    reprintCombinedPdf: "",
    reprintingProgress: 0
};

export {
    initialStateActivitiy,
    initialStateAuth,
    initialStateConsumptionDetails,
    initialStateLabelling,
    initialStateModalPallets2,
    initialStatePalletCache,
    initialStatePalletEdit,
    initialStatePalletSearch,
    initialStateWorkorderitems,
    initialStateWorkorderManagement,
    initialStatePrintHistoryFooters,
    initialStateAdmin,
    initialStateSchedules,
    initialStateReprint
};
